module.exports = "/static/assets/bfb4e4698a86df5f18d0bc345580142e.png";